export const en = {
    'vcard-city-letters': 'Name of city may only contain letters',
    'vcard-city-max-length': 'Name of city may not exceed {maxLength} characters',
    'vcard-city-no-empty': 'Enter a city',
    'vcard-country-letters': 'Name of country may only contain letters',
    'vcard-country-max-length': 'Name of country may not exceed {maxLength} characters',
    'vcard-country-no-empty': 'Enter a country',
    'vcard-descr-format': 'Description may only contain letters, numbers, and punctuation marks',
    'vcard-descr-max-length': 'Description may not exceed {maxLength} characters',
    'vcard-descr-no-empty': 'Enter a description',
    'vcard-error-text': 'An unexpected error occurred: {code}/{code}. Try again later.',
    'vcard-house-max-length': 'House number may not exceed {maxLength} characters',
    'vcard-house-no-empty': 'Enter a house number',
    'vcard-mail-format': 'Invalid email address',
    'vcard-mail-max-length': 'Email address may not exceed {maxLength} characters',
    'vcard-mail-no-empty': 'Enter an email address',
    'vcard-messenger-icq-format': 'Invalid ICQ username',
    'vcard-messenger-jabber-format': 'Invalid JABBER username',
    'vcard-messenger-login-length': 'Username may not exceed {maxLength} characters',
    'vcard-messenger-mailruagent-format': 'Invalid Mail.Ru Agent username',
    'vcard-messenger-skype-or-msn-format': 'Invalid username',
    'vcard-name-letters': 'Name may only contain letters, numbers, and punctuation marks',
    'vcard-name-max-length': 'Name may not exceed {maxLength} characters',
    'vcard-name-no-empty': 'Enter a company name',
    'vcard-need-to-save': 'Finish editing the business card before saving the ad',
    'vcard-office-format': 'Office numbers may only contain letters, numbers, and punctuation marks',
    'vcard-office-max-length': 'The number of characters in this field may not exceed {maxLength}',
    'vcard-office-no-empty': 'Enter an office number',
    'vcard-ogrn-format': 'Invalid OGRN/OGRNIP ',
    'vcard-ogrn-no-empty': 'Enter an OGRN/OGRNIP',
    'vcard-phone-city-code-format': 'Invalid area code',
    'vcard-phone-city-code-length': 'City code may not exceed {maxLength} characters',
    'vcard-phone-city-code-no-empty': 'Enter a city code',
    'vcard-phone-country-code-format':
        'Country code must start with "+" and contain from 1 to 4 numbers. Country code 8 may also be used in combination with regional code 800.',
    'vcard-phone-country-code-length': 'Country code may not exceed {maxLength} characters',
    'vcard-phone-country-code-no-empty': 'Enter a country code',
    'vcard-phone-country-code-start-no-plus':
        'Country code may be 8 or 0. In combination with regional codes, 8 800, 8 804, and 0 800 may be entered.',
    'vcard-phone-country-code-start-plus': 'Enter a "+" before the country code',
    'vcard-phone-extension-format': 'Invalid extension',
    'vcard-phone-extension-max-length': 'Extension may not exceed {maxLength} characters',
    'vcard-phone-number-format': 'Invalid phone number',
    'vcard-phone-number-max-length': 'Phone number may not exceed {maxLength} characters',
    'vcard-phone-number-min-length': 'Phone number must contain at least {minLength} characters',
    'vcard-phone-number-no-empty': 'Enter a phone number',
    'vcard-street-letters': 'Street name may only contain letters, numbers, and punctuation marks',
    'vcard-street-max-length': 'Street name may not exceed {maxLength} characters',
    'vcard-street-no-empty': 'Enter a street'
};
